import React, { useState } from 'react';
import { Stack, Typography, FormControl, MenuItem, Theme, useMediaQuery } from '@mui/material';
import { FC } from 'react';
import { User } from 'src/constants/types';
import { InlineSelect } from './InlineSelect.styles';

type AssignUserFormProps = {
  currentCompanyId: string;
  contactId: string;
  assignedUserId: string | undefined;
  users: User[];
  submitAssignUser: (companyId: string, contactId: string, userId: string) => Promise<void>;
};

export const AssignUserForm: FC<AssignUserFormProps> = props => {
  const { currentCompanyId, contactId, assignedUserId, users, submitAssignUser } =
    props;

  const [userId, setUserId] = useState<string>(assignedUserId || "");
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  const formatUserName = (user: User): string => {
    if (user.firstName || user.lastName) {
      return `${user.firstName || ''} ${user.lastName || ''}`;
    }

    return user.phoneNumber;
  };

  return (
    <Stack direction="row" alignItems="center" gap={isMobile ? 1 : 1.25}>
      <Typography
        fontSize={15}
        fontWeight={isMobile ? 'fontWeightSemiBold' : 'fontWeightRegular'}
        mr={isMobile ? 0 : 1.25}
      >
        Assignee:
      </Typography>
      <FormControl variant="standard">
        <InlineSelect
          displayEmpty
          value={userId || ''}
          onChange={async ({ target }) => {
            const value = target.value as string;
            setUserId(value);
            await submitAssignUser(currentCompanyId, contactId, value || '');
          }}
          sx={{ minWidth: isMobile ? 160 : 150 }}
        >
          <MenuItem value={''} key={'unassign'}>
            Unassigned
          </MenuItem>
          {users?.map(item => {
            return (
              <MenuItem value={item.id} key={item.id}>
                {formatUserName(item)}
              </MenuItem>
            );
          })}
        </InlineSelect>
      </FormControl>
    </Stack>
  );
};
